/* eslint-disable no-restricted-syntax */
// DI token constants isolated in their own module to avoid circular import
// issues between the container, services, and other DI participants.
export const DI_TOKENS = {
  ROOT_STORE: 'RootStore',
  VIDEO_CREATOR_STORE: 'VideoCreatorStore',
  STORY_CREATION_SERVICE: 'StoryCreationService',
  UPLOAD_WORKER_PROVIDER: 'UploadWorkerProvider',
  UPLOAD_SERVICE: 'UploadService',
  SERVICE_CONTAINER: 'ServiceContainer',
} as const;

export type DITokenMap = typeof DI_TOKENS;
export type DIToken = DITokenMap[keyof DITokenMap];
